import React from 'react';
import './KtmbTimetableCard.css';
//for testing
//const tripData = 'MzBPTHp4b01BSndkZVhxa1hjUU9SSHdSYjlTOHA2WVdSeDh5MklubXVtYVJ4NERqUittaGNOVFdyZkdLbXpZUVBaZjhDMDBuTTA0RDdnTVNYWVE1V2VkcWVFTDNWZ0VPV0dIL3JBNzlaT3h0VmxTZ3V2S3VZMnpOOTVodVJ2TmExWkRIQWh5YWd1d21hKysrQzg1YWpWOWRYL21tQ0ErK29LZkFJSC9BNm04Y3FmekcvQXR3T0JyTXc2Wm95MnMzdEMvelFJRForMk5BR3dUek1FS1dyRmFHZ3VqaERUaXJyNXF5UDl0UTNMMGViRDVNR05hZ1dveHlXd3BEYitOb3ZvQm9HLzhDZkhTZzF2KzJob0pselYrMitWVnVFWGZ4NFJYblJwVlp3dlZlbWZVQnlIbVJEejZZV28wRlZKaHo%3d';
const KtmbTimetableCard = ({ from, to, timetable, departureTime }) => {
  if (!timetable || !Array.isArray(timetable) || timetable.length === 0) {
    return null;
  }

  const formatTime = (timeString) => {
    if (!timeString) return '';

    // Handle ISO format strings like "2025-06-22T09:50:00Z" or "...+08:00"
    if (timeString.includes('T')) {
      const date = new Date(timeString);
      // Check if the date is valid
      if (isNaN(date.getTime())) {
        return timeString; // Return original string if parsing fails
      }
      return date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });
    }

    // Fallback for regular time format like "09:50"
    const [hours, minutes] = timeString.split(':');
    const hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour % 12 || 12;
    return `${displayHour}:${minutes} ${ampm}`;
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'scheduled':
        return '#28a745';
      case 'delayed':
        return '#ffc107';
      case 'cancelled':
        return '#dc3545';
      default:
        return '#6c757d';
    }
  };

  const getTripColor = (color) => {
    return color || '#7CFC00';
  };

  const handleBuyTicket = (buyTicketTripData) => {
    const etsUrl = process.env.REACT_APP_ACTION_URL;
    // const etsUrl = process.env.REACT_APP_ETS_URL;
    if (etsUrl && buyTicketTripData) {
      const redirectUrl = `${etsUrl}?param1=${buyTicketTripData}`;
      console.log("redirectUrl", redirectUrl);
      window.open(redirectUrl, '_blank');
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const options = { 
      weekday: 'short', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    };
    return date.toLocaleDateString('en-US', options);
  };

  return (
    <div className="ktmb-timetable-card">
      {/* <div className="ktmb-header">
        <div className="header-main">
          <div className="ktmb-route">
            <div className="route-stations">
              <span className="station from">{from || 'Origin'}</span>
              <div className="route-arrow">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </div>
              <span className="station to">{to || 'Destination'}1212eee</span>
            </div>
          </div>
          <div className="ktmb-logo">
            <span className="ktmb-badge">KTMB</span>
          </div>
        </div>
        {departureTime && (
          <div className="header-date-row">
            <div className="departure-date">{formatDate(departureTime)}</div>
          </div>
        )}
      </div> */}

      <div className="timetable-list">
        {timetable.map((train, index) => (
          <div key={index} className="train-item">
            <div className="train-header">
              <div className="train-number">
                <span className="train-icon">🚆</span>
                {train.trainService} {train.trainNo}
              </div>
              <div className="train-status">
                {train.tripStatusLabel && (
                  <div 
                    className="status-badge"
                    style={{ backgroundColor: getStatusColor(train.tripStatusLabel) }}
                  >
                    {train.tripStatusLabel}
                  </div>
                )}
                {train.tripRightUpLabel && (
                  <div 
                    className="trip-badge"
                    style={{ backgroundColor: getTripColor(train.tripRightUpLabelColor) }}
                  >
                    {train.tripRightUpLabel}
                  </div>
                )}
              </div>
            </div>

            <div className="train-schedule">
              <div className="time-row">
                <div className="time-block">
                  <span className="time-label">Depart</span>
                  <span className="time-value">{formatTime(train.departTime)}</span>
                </div>
                <div className="journey-info">
                  <span className="journey-time">{train.journeyTime}</span>
                  <span className="departure-in">{train.departureInTimeString}</span>
                </div>
                <div className="time-block">
                  <span className="time-label">Arrive</span>
                  <span className="time-value">{formatTime(train.arrivalTime)}</span>
                </div>
              </div>
            </div>

            <div className="train-footer">
              <div className="train-details">
                {train.platformNo && (
                  <div className="platform">
                    Platform {train.platformNo}
                  </div>
                )}
                {train.fare && (
                  <div className="ktmb-fare">
                    {train.fare}
                  </div>
                )}
                {train.seat && (
                  <div className="seat">
                    Seat: {train.seat}
                  </div>
                )}
                {train.price && train.currency && (
                  <div className="price">
                    {train.currency} {train.price}
                  </div>
                )}
                {train.serviceCategory && (
                  <div className="service-category">
                    {train.serviceCategory}
                  </div>
                )}
              </div>
              
              {train.pdata && (
                <div className="buy-ticket-section">
                  <button 
                    className="buy-ticket-btn"
                    onClick={() => handleBuyTicket(train.pdata)}
                  >
                    Buy Ticket
                     {/* {train.buyTicketTripData} */}
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KtmbTimetableCard;
